module.exports = "pegasus/assets/themelp1/tickets/bg.png";